import { FormField } from "components/form/FormField/FormField";

import style from "../CervicalCheck.module.css";

export const SampleTakersDetails = ({ form }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
          marginTop: "24px",
        }}
      >
        Sample Takers Details
      </h2>
      <div className={style.inputGroupGrid}>
        <FormField name="mcrnOrNmbi">
          <label className={style.addLetterFormLabel}>MCRN or NMBI</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("mcrnOrNmbi")}
            />
          </div>
        </FormField>
        <FormField name="sampletakerName">
          <label className={style.addLetterFormLabel}>Sample Takers Name</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("sampletakerName")}
            />
          </div>
        </FormField>
      </div>
    </>
  );
};
